export default __webpack_public_path__ + "static/media/waste-removal.63c70629.svg";